import DiscountsAPIs from '@/API/promotions/discounts-api'

export default {
  namespaced: true,
  state: {
    discountsCount: null,
    discountsData: [],
  },

  getters: {
    discountsCount: (state: any) => state.discountsCount,
    discounts: (state: any) => state.discounts,
  },

  mutations: {
    SET_DISCOUNTS_COUNT(state: any, discountsCount: number) {
      state.discountsCount = discountsCount
    },
    SET_DATA(state: any, data: any) {
      state.discounts = data.discounts
    },
  },
  actions: {
    async FETCH_DISCOUNTS(context: any) {
      try {
        const branchId = context.rootGetters['branches/currentBranchId']
        const data = await DiscountsAPIs.getDiscounts(branchId, {})
        context.commit('SET_DATA', data)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
